var map = {
	"./argentina-logo-icon.webp": 23908,
	"./australia-logo-icon.webp": 42343,
	"./benetton-rugby-logo-icon.webp": 8948,
	"./blue-bulls-logo-icon.webp": 66028,
	"./boland-kavaliers-logo-icon.webp": 26558,
	"./bristol-bears-logo-icon.webp": 17856,
	"./bulls-logo-icon.webp": 2687,
	"./canada-logo-icon.webp": 99957,
	"./cardiff-rugby-logo-icon.webp": 6330,
	"./chile-logo-icon.webp": 92560,
	"./connacht-rugby-logo-icon.webp": 66767,
	"./default-logo-icon.webp": 54220,
	"./dragons-rfc-logo-icon.webp": 14233,
	"./edinburgh-rugby-logo-icon.webp": 65743,
	"./england-logo-icon.webp": 46464,
	"./fiji-logo-icon.webp": 56131,
	"./france-logo-icon.webp": 26624,
	"./georgia-logo-icon.webp": 78841,
	"./glasgow-warriors-logo-icon.webp": 13421,
	"./griquas-logo-icon.webp": 62339,
	"./hong-kong-logo-icon.webp": 46593,
	"./ireland-logo-icon.webp": 10862,
	"./italy-logo-icon.webp": 61342,
	"./japan-logo-icon.webp": 45621,
	"./leinster-rugby-logo-icon.webp": 74037,
	"./lions-logo-icon.webp": 40734,
	"./munster-rugby-logo-icon.webp": 67355,
	"./new-zealand-logo-icon.webp": 21303,
	"./northhampton-logo-icon.webp": 80093,
	"./ospreys-logo-icon.webp": 61682,
	"./portugal-logo-icon.webp": 76897,
	"./pumas-logo-icon.webp": 65799,
	"./romania-logo-icon.webp": 37602,
	"./samoa-logo-icon.webp": 70706,
	"./scarlets-logo-icon.webp": 69524,
	"./scotland-logo-icon.webp": 34931,
	"./sharks-logo-icon.webp": 22077,
	"./sharks-xv-logo-icon.webp": 66170,
	"./south-africa-logo-icon.webp": 52929,
	"./spain-logo-icon.webp": 41060,
	"./stormers-logo-icon.webp": 46956,
	"./tonga-logo-icon.webp": 12172,
	"./toyota-cheetahs-logo-icon.webp": 93063,
	"./ulster-rugby-logo-icon.webp": 82340,
	"./uruguay-logo-icon.webp": 10129,
	"./usa-logo-icon.webp": 8394,
	"./wales-logo-icon.webp": 90933,
	"./western-province-logo-icon.webp": 77106,
	"./zebre-parma-logo-icon.webp": 54645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35528;